import { acceptHMRUpdate, defineStore } from "pinia";
import {get as _get, has as _has} from 'lodash-es';

export const useBookingAppSettingStore = defineStore('booking-app-settings', {
	state: () => ({
		viewMode: import.meta.env.VITE_VIEW_MODE || 'dev',
		snackbar: {
			show: false,
			text: '',
			timeout: 2000,
		},
		/**
		 * @deprecated
		 */
		loader: {
			show: false,
			title: null,
			titleHTML: null,
			text: null,
			textHTML: null,
			showActions: null,
			actions: {
				left: null,
				right: null
			},
			persistent: true,
			progressBar: true,
		},
		alert: {
			show: false,
			message: '',
			type: 'error'
		},
		display: {
			footer: null,
			seats: null
		}
		// currency: {
		// 	EUR: '€'
		// }
	}),
	actions: {
		/**
		 * @deprecated
		 */
		showLoader(title){
			this.loader.title = title;
			this.loader.show = true;
			this.loader.persistent = true;
			this.loader.progressBar = true;
			this.loader.text = null;
		},
		/**
		 * @deprecated
		 */
		closeLoader(){
			this.loader.show = false;
			this.loader.title = null;
		},
		showAlert(type, message){
			this.alert.show = true;
			this.alert.type = type;
			this.alert.message = message;
		},
		hideAlert(){
			this.alert.show = false;
			this.alert.type = 'error';
			this.alert.message = null;
		}
	}
});

if(import.meta.hot){
	import.meta.hot.accept(acceptHMRUpdate(useBookingAppSettingStore, import.meta.hot));
}